import { render, staticRenderFns } from "./FinanceNicheIcon.vue?vue&type=template&id=bcf713b2&scoped=true"
import script from "./FinanceNicheIcon.vue?vue&type=script&lang=js"
export * from "./FinanceNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf713b2",
  null
  
)

export default component.exports